import Cookie from 'js-cookie'
import { jwtDecode } from 'jwt-decode';

function UserData() {
    let access_token = Cookie.get("access_token")
    let refresh_token = Cookie.get("refresh_token")

    if (access_token && refresh_token) {
        try {
            const token = refresh_token
            const decoded = jwtDecode(token)
            // Removed console.log to prevent infinite printing
            return decoded
        } catch (error) {
            console.error('Error decoding token:', error);
            return null;
        }
    } else {
        return null;
    }
}

export default UserData